import React from 'react';
import '../../../assets/whypc/css/player.css';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css';
import { Link } from 'react-router-dom';

const CustomPlayButton = ({ onClick }) => (
    <button className="custom-play-button" onClick={onClick}>
        <span className="play-icon"></span>
    </button>
);

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           courseId : this.getQueryString(this.props.location.search, 'id') || '',
           showPlayButton: true
        }
        this.playerRef = React.createRef();
    }

    getQueryString = (url, name) => {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = url.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    }

    handlePlay = () => {
        if (this.playerRef.current) {
            this.playerRef.current.play();
            this.setState({ showPlayButton: false });
        }
    }

    handlePause = () => {
        this.setState({ showPlayButton: true });
    }

    handlePlayEvent = () => {
        this.setState({ showPlayButton: false });
    }

    render() {
        const { courseId, showPlayButton } = this.state;

        if (!courseId) {
            return (
                <div className="player-container">
                    <div className="preview-header">
                        <Link to="/video" className="back-btn">
                            <span className="arrow">←</span> 返回
                        </Link>
                    </div>
                    <div className="error-message">
                        <p>未找到视频链接</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="player-container">
                <div className="preview-header">
                    <Link to="/video" className="back-btn">
                        <span className="arrow">←</span> 返回
                    </Link>
                </div>

                <div className="player-wrapper">
                    <div className="video-player-container" onContextMenu={(e) => e.preventDefault()}>
                        <Player
                            ref={this.playerRef}
                            playsInline
                            poster=""
                            src={"https://culture.hnbxwhy.com/yanxue/videoPreview/streamPlay?courseId="+courseId+"&type=1"}
                            className="video-player"
                            bigPlayButton={false}
                            onPause={this.handlePause}
                            onPlay={this.handlePlayEvent}
                        />
                        {showPlayButton && <CustomPlayButton onClick={this.handlePlay} />}
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoPlayer;